import React, { useState, useEffect, useRef, useCallback } from 'react';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import { InputSwitch } from 'primereact/inputswitch';
import { useTranslation } from 'react-i18next';
import { vrstaOpis, kasnjenjeTeksta, VRSTE } from './incidenti';
/* Isti formater koji koristi i oblacic na mapi — da se kartica i trasa ne
   raziđu u nacinu na koji ispisuju isto vreme. */
import { trajanje as sat } from './stajanja';
import { googleLinkRute, otvoriGoogle, uzorakTrase, kopirajLink } from './googleLinkovi';

/* „Kuda da pošaljem ovo vozilo" — planiranje rute sa predlozima.

   ── PO ČEMU SE OVO RAZLIKUJE OD RUTE NA MAPI ──────────────────────────────
   Ruta koja se crta pri izboru vozila je ISTORIJA: gde je vozilo bilo. Ovde je
   PLAN: gde tek ide. Zato se radovi i blokade traže samo ovde — javljati ih
   nad pređenim putem nema smisla.

   ── ZAŠTO VIŠE PREDLOGA ───────────────────────────────────────────────────
   Jedna „najbolja" ruta ne pomaže kad se odlučuje. Dve trase koje se razlikuju
   po deset minuta mogu se razlikovati po tome što je na jednoj zatvoren put —
   a to se vidi tek kad stoje jedna pored druge. Zato svaki predlog nosi i
   koliko KASNI zbog trenutnog saobraćaja i šta ga na putu čeka.

   ── REDOSLED PODATAKA U KARTICI ───────────────────────────────────────────
   Vreme pa kilometri pa upozorenja. Dispečer bira po vremenu; kilometri su
   provera; upozorenja su ono što tu odluku ume da obori. */


/* Sažetak upozorenja na jednoj trasi. Zatvoreni putevi se broje ODVOJENO i ne
   ulaze u zbir kašnjenja: zatvoren put nije „plus dvadeset minuta" nego „ovuda
   se ne prolazi". */
const sazetak = (lista) => {
    const l = lista || [];
    return {
        ukupno: l.length,
        zatvorenih: l.filter(x => x.zatvoren).length,
        radova: l.filter(x => x.vrsta === 'RADOVI').length,
    };
};

/* Police u koje se slazu predlozi odredista, redom kojim se prikazuju.

   Redosled je redosled verovatnoce, ne azbuka: mesto koje firma vec vozi je
   verovatnije odrediste od bilo cega sto vrati pretraga po svetu, pa nasi
   podaci idu prvi. Posle njih mesta (najsiri pojam), pa adrese, pa objekti.

   Gornja granica po polici postoji da jedna ne poplavi spisak: upit „Vrbas"
   vraca sest objekata i jedan grad, pa bi grad bez ogranicenja zavrsio ispod
   pregiba iako je verovatno bas on trazen. */
/* Ikona kaže o kojoj je VRSTI odredišta reč i pre nego što se pročita naslov
   police — bitno kad se spisak gleda krajičkom oka dok se kuca. */
/* Pretraga kreće TEK PREKO tri znaka, dakle od četvrtog.

   Na tri znaka gotovo svaki upit je još uvek početak nečega („BEO", „NOV",
   „MAR"), pa rezultati ionako nisu upotrebljivi — a svaki takav upit je
   potrošen poziv. TomTom Search u besplatnom nivou ima 2 500 poziva mesečno,
   i to je najtesnija kvota koju imamo; tri dispečera koja dnevno traže po
   desetak odredišta već je grebu. Prva tri znaka su najskuplji deo kucanja i
   najmanje vrede. */
const NAJMANJE_ZNAKOVA = 4;

const IKONA_POLICE = {
    NASI:   'pi pi-map-marker',
    MESTO:  'pi pi-globe',
    ADRESA: 'pi pi-map',
    FIRMA:  'pi pi-building',
};

const POLICE = [
    { kljuc: 'NASI',   naslov: 'gps.planGrupaNasi',   koliko: 4 },
    { kljuc: 'MESTO',  naslov: 'gps.planGrupaMesta',  koliko: 3 },
    { kljuc: 'ADRESA', naslov: 'gps.planGrupaAdrese', koliko: 4 },
    { kljuc: 'FIRMA',  naslov: 'gps.planGrupaFirme',  koliko: 4 },
];

const DialogPlanRute = ({ vidljiv, vozilo, zovi, onZatvori, onRute, onIzabrana, onOdrediste }) => {
    const { t, i18n } = useTranslation();

    const [upit, setUpit]             = useState('');
    const [predlozi, setPredlozi]     = useState([]);
    const [trazi, setTrazi]           = useState(false);
    const [odrediste, setOdrediste]   = useState(null);
    const [putarine, setPutarine]     = useState(false);
    const [rute, setRute]             = useState([]);
    const [izabrana, setIzabrana]     = useState(null);
    const [racuna, setRacuna]         = useState(false);
    const [poruka, setPoruka]         = useState(null);
    /* Kopiranje nema svoj prozor ni tost — potvrda je sâmo dugme, koje na dve
       sekunde postane kvačica. Radnja je sitna i trenutna, pa i potvrda treba
       da bude takva; tost bi za ovo bio preglasan. */
    const [kopirano, setKopirano]     = useState(false);

    /* Prozor sklonjen u traku pri dnu. Trase pritom OSTAJU na mapi — to je
       cela svrha: plan se pravi u prozoru, a proverava na mapi, i za to se
       ne sme traziti da se plan odbaci. */
    const [smanjen, setSmanjen] = useState(false);

    const brojac = useRef(0);

    /* Tekst koji je VEC razresen u odrediste. Dok se polje poklapa sa njim,
       pretraga se ne pokrece.

       Ovde je ranije stajala zastavica koja se trosi jednom — i to je bio bug
       „spisak se opet otvori posto sam vec izabrao". Efekat se ne pokrece samo
       kad se promeni tekst: medju njegovim zavisnostima su i `zovi` i `t`, a
       `zovi` se pravi sa `[auth.token, t]`, pa dobija novi identitet kad god
       `t` dobije svoj. Zastavica je do tada vec bila potrosena, pa je drugo
       pokretanje proslo i spisak se vratio.

       Pamcenje TEKSTA umesto jednokratne zastavice ne zavisi od toga koliko se
       puta efekat pokrene: dok korisnik ne otkuca nesto drugo, nema sta da se
       trazi. */
    const razreseno = useRef(null);

    /* Svako otvaranje kreće od čistog: prošli plan je bio za drugo vozilo ili
       drugo odredište, a zaostao bi kao da važi. */
    useEffect(() => {
        if (!vidljiv) return;
        setUpit(''); setPredlozi([]); setOdrediste(null);
        setRute([]); setIzabrana(null); setPoruka(null);
        onOdrediste(null);
        razreseno.current = null;
        /* I traka se vraca u pun prozor: sledeci put se krece od pocetka, a
           traka bez plana nema sta da pokaze. */
        setSmanjen(false);
    }, [vidljiv, vozilo?.mobilisis_id]);

    /* ---- pretraga odredišta ----
       Ista pretraga kao u zaglavlju mape, pa nalazi i NAZIVE FIRMI, ne samo
       adrese — odredište je najčešće firma, a ne ulica i broj. */
    useEffect(() => {
        if (razreseno.current !== null && razreseno.current === upit) {
            setPredlozi([]);
            return undefined;
        }

        const q = upit.trim();
        if (q.length < NAJMANJE_ZNAKOVA) { setPredlozi([]); return undefined; }

        const moj = ++brojac.current;
        setTrazi(true);
        const tajmer = setTimeout(async () => {
            try {
                /* Pretraga se naginje ka poziciji VOZILA: odrediste je najcesce
                   u istoj zemlji ili susednoj, a bez toga TomTom za srpske
                   firme ume da vrati hrvatske — provereno. */
                const d = await zovi('/gps/pretraga', {
                    upit: q, izvori: ['ADRESA', 'LOKACIJA'], jezik: i18n.language,
                    lat: vozilo?.lat, lng: vozilo?.lng,
                });
                if (brojac.current !== moj) return;

                /* Naši podaci idu ISPRED adresa sa mape: mesto koje je firma
                   već koristila je verovatnije odredište od bilo čega što
                   vrati pretraga po celom svetu. */
                /* Klijenti iz nase baze NEMAJU sacuvane koordinate — vade se tek
                   kad se izaberu (`/gps/geokodiraj`). Ranije ih je odsecao filter
                   `lat != null`, pa se „Šarčević Co Vrbas" nije mogao naci iako
                   je u bazi: to je bio bug „ne mogu da nadjem Sarcevic u Vrbasu". */
                const lokacije = (d?.LokacijeDB || [])
                    .map(x => ({
                        naziv: x.naziv,
                        opis: [x.adresa, x.grad].filter(Boolean).join(', '),
                        lat: x.lat, lng: x.lng,
                        zemlja: x.oznaka,
                        svoje: true,
                        /* Klijent i rucno sacuvana lokacija su oba nasi podaci, ali
                           nisu isto — znacka zato imenuje sta je zapis stvarno. */
                        znacka: x.izvor === 'KLIJENT' ? t('gps.pretragaKlijent') : t('gps.pretragaSacuvana'),
                        /* Podaci za naknadno geokodiranje, kad tacke nema. */
                        adresa: x.adresa, grad: x.grad, drzava: x.drzava,
                    }));
                const adrese = (d?.AdreseDB || [])
                    .map(x => ({
                        naziv: String(x.naziv).split(',')[0],
                        opis: String(x.naziv).split(',').slice(1).join(',').trim(),
                        lat: x.lat, lng: x.lng,
                        zemlja: x.oznaka,
                        /* Policu odredjuje pozadina — ona zna da je „Vrbas" grad,
                           „Kralja Petra 12" adresa, a „Pošta Vrbas" objekat. */
                        polica: x.vrsta || 'ADRESA',
                    }));

                /* Svaka polica se puni do svoje granice i tek onda spaja — da
                   jedan upit sa mnogo objekata ne istisne jedini grad. */
                const izvuci = (kljuc, koliko) => (kljuc === 'NASI'
                    ? lokacije
                    : adrese.filter(x => x.polica === kljuc)).slice(0, koliko);

                setPredlozi(POLICE.flatMap(g => izvuci(g.kljuc, g.koliko)
                    .map(x => ({ ...x, polica: g.kljuc }))));
            } catch (e) {
                if (brojac.current === moj) setPredlozi([]);
            } finally {
                if (brojac.current === moj) setTrazi(false);
            }
        }, 350);

        return () => clearTimeout(tajmer);
    }, [upit, zovi, i18n.language, t, vozilo?.lat, vozilo?.lng]);

    /* ---- računanje ---- */
    const izracunaj = useCallback(async (cilj, bezPutarina) => {
        if (!cilj || !vozilo?.mobilisis_id) return;
        setRacuna(true);
        setPoruka(null);
        try {
            const d = await zovi('/gps/planRute', {
                mobilisis_id: vozilo.mobilisis_id,
                odrediste: { lat: cilj.lat, lng: cilj.lng },
                izbegavajPutarine: !!bezPutarina,
                jezik: i18n.language,
            });

            if (d?.greska) {
                setRute([]); onRute([]);
                setPoruka(t(`gps.plan${d.greska === 'NEMA_POZICIJE' ? 'NemaPozicije' : 'Greska'}`));
                return;
            }
            const r = d?.rute || [];
            setRute(r);
            setIzabrana(r.length ? 0 : null);
            onRute(r);
            onIzabrana(r.length ? 0 : null);
            if (!r.length) setPoruka(t('gps.planNemaRute'));
        } catch (e) {
            setRute([]); onRute([]);
            setPoruka(e.message);
        } finally {
            setRacuna(false);
        }
    }, [vozilo, zovi, i18n.language, t, onRute, onIzabrana]);

    const izaberiOdrediste = async (p) => {
        razreseno.current = p.naziv;
        setUpit(p.naziv);
        setPredlozi([]);

        /* Klijent iz nase baze nema tacku dok se ne zatrazi. Geokodira se TEK
           OVDE, a ne za svaki red u spisku: Nominatim ide jedan upit u sekundi,
           pa bi osam rezultata zamrzlo pretragu na osam sekundi. */
        let cilj = p;
        if (p.lat == null || p.lng == null) {
            setRacuna(true);
            setPoruka(null);
            try {
                const g = await zovi('/gps/geokodiraj', { adresa: p.adresa, grad: p.grad, drzava: p.drzava });
                if (g?.lat == null) {
                    setRacuna(false);
                    setPoruka(t('gps.pretragaNemaKoordinate'));
                    return;
                }
                cilj = { ...p, lat: g.lat, lng: g.lng };
            } catch (e) {
                setRacuna(false);
                setPoruka(t('gps.pretragaNemaKoordinate'));
                return;
            }
        }

        setOdrediste(cilj);
        /* Mapa mora da zna gde je cilj da bi tamo zabola zastavicu — prozor
           se moze skloniti, a tacka ostaje. */
        onOdrediste(cilj);
        izracunaj(cilj, putarine);
    };

    /* Brisanje odredista vraca polje u pretragu. Bez ovoga se izabrano mesto
       moze promeniti samo brisanjem teksta slovo po slovo. */
    const ocistiOdrediste = () => {
        razreseno.current = null;
        setOdrediste(null);
        setUpit('');
        setPredlozi([]);
        setRute([]); setIzabrana(null); setPoruka(null);
        onRute([]); onIzabrana(null); onOdrediste(null);
    };

    const promeniPutarine = (v) => {
        setPutarine(v);
        if (odrediste) izracunaj(odrediste, v);
    };

    const izaberiRutu = (i) => {
        setIzabrana(i);
        onIzabrana(i);
    };

    /* Link do IZABRANE trase, a ne bilo koje.

       Sa samo dve tačke Google računa svoju rutu i pokaže ono što on smatra
       najboljim — a to ume da bude druga trasa od one koju je dispečer izabrao,
       i izabrao ju je sa razlogom (manje radova, bez putarine). Zato se iz naše
       trase uzima do devet međutačaka, pa Google vodi istim putem. */
    const vezaGoogle = () => {
        if (!vozilo || !odrediste) return null;
        const trasa = izabrana != null ? rute[izabrana] : null;
        return googleLinkRute(
            [
                { lat: vozilo.lat, lng: vozilo.lng },
                ...uzorakTrase(trasa?.geometrija),
                { lat: odrediste.lat, lng: odrediste.lng },
            ],
            { izbegavajPutarine: putarine }
        );
    };

    const naGoogle = () => otvoriGoogle(vezaGoogle());

    const naKopiraj = async () => {
        const uspelo = await kopirajLink(vezaGoogle());
        if (!uspelo) { setPoruka(t('gps.googleNeuspelo')); return; }
        setKopirano(true);
        setTimeout(() => setKopirano(false), 2000);
    };

    /* Sklonjen u traku: prozor se ne unistava nego se zamenjuje uskom trakom
       pri dnu. Trase ostaju na mapi jer o njima vodi racun GPS.js — ovde se
       menja samo sta se vidi.

       Ovo resava „nemam gde da spustim prozor da vidim mapu, a Zatvori gasi
       sve": provera plana JESTE gledanje mape, pa je trazenje da se plan
       odbaci zarad pogleda na mapu bilo trazenje da se odustane od posla
       zbog koga je prozor i otvoren. */
    if (vidljiv && smanjen) {
        const r = izabrana != null ? rute[izabrana] : null;
        return (
            <div className="gps-plan-traka">
                <i className="pi pi-truck gps-plan-traka-ikona" />
                <span className="gps-plan-traka-put">
                    <strong>{vozilo?.registracija}</strong>
                    <i className="pi pi-arrow-right" />
                    <span className="gps-plan-traka-cilj">
                        {odrediste?.naziv || t('gps.planOdredistePlaceholder')}
                    </span>
                </span>

                {!!r && (
                    <span className="gps-plan-traka-sazetak">
                        <span className="gps-plan-broj">{izabrana + 1}</span>
                        <strong>{sat(r.minuta)}</strong>
                        <span>{r.km.toLocaleString('sr-RS', { maximumFractionDigits: 1 })} km</span>
                    </span>
                )}

                <button type="button" className="gps-plan-traka-dugme"
                        onClick={() => setSmanjen(false)}
                        title={t('gps.planVrati')} aria-label={t('gps.planVrati')}>
                    <i className="pi pi-window-maximize" />
                </button>
                <button type="button" className="gps-plan-traka-dugme"
                        onClick={onZatvori}
                        title={t('common.close')} aria-label={t('common.close')}>
                    <i className="pi pi-times" />
                </button>
            </div>
        );
    }

    return (
        <Dialog
            header={t('gps.planNaslov')}
            visible={vidljiv}
            onHide={onZatvori}
            className="gps-dijalog-plan"
            style={{ width: '56rem', maxWidth: '96vw' }}
            /* Sadrzaj se NAMERNO ne sece (`overflow: visible`): padajuci spisak
                odredista je apsolutno pozicioniran, pa ga svaki `overflow: auto`
                na roditelju odseca — to je bio bug „ne vidim popup ceo".
                Visina se drzi time sto predlozi trasa stoje u REDU, a ne jedan
                ispod drugog; jedini deo koji ume da naraste (spisak upozorenja)
                ima svoj skrol. */
            contentStyle={{ overflow: 'visible' }}
            draggable={false}
            /* Stoji levo od „x": sklanja prozor, ne odbacuje plan. */
            icons={(
                <button type="button" className="p-dialog-header-icon p-link"
                        onClick={() => setSmanjen(true)}
                        title={t('gps.planSmanji')} aria-label={t('gps.planSmanji')}>
                    <span className="pi pi-window-minimize" />
                </button>
            )}
        >
            {/* Polazište i odredište stoje JEDNO PORED DRUGOG: to je jedan
                podatak u dva dela („odakle → kuda"), pa ih čitanje odozgo
                nadole razdvaja iako se razumeju zajedno. Uz to se dobija
                visina, koje u ovom prozoru nema napretek. */}
            <div className="gps-plan-red">
            {/* Polazište se ne bira — ono je tamo gde vozilo jeste. Stoji kao
                podatak, ne kao polje, da se ne bi tražilo da se popuni.

                Ipak nosi oznaku iznad, kao i odredište: bez nje je desna strana
                imala naslov a leva ne, pa su polja počinjala na različitoj
                visini i red je izgledao slomljeno. Dva dela istog podatka
                („odakle → kuda") moraju i da počinju u istoj liniji. */}
            <div className="gps-plan-polje gps-plan-polje-od">
                <div className="gps-plan-oznaka">{t('gps.planPolazisteLabela')}</div>
                <div className="gps-plan-od">
                    <i className="pi pi-truck" />
                    {/* Registracija i napomena u JEDNOM redu — dva reda su ovu
                        stranu činila višom od polja za odredište. */}
                    <span className="gps-plan-od-tekst">
                        <strong>{vozilo?.registracija}</strong>
                        <span>{t('gps.planPolaziste')}</span>
                    </span>
                </div>
            </div>

            <div className="gps-plan-polje">
                <label className="gps-plan-oznaka" htmlFor="plan-cilj">{t('gps.planOdrediste')}</label>
                {/* Kad je odrediste izabrano, polje to i POKAZUJE: kvacica umesto
                    lupe i zelen okvir. Bez toga izabrano i otkucano izgledaju isto,
                    pa se ne zna da li je izbor primljen. */}
                <div className={`gps-plan-unos${odrediste ? ' gps-plan-unos-potvrdjen' : ''}`}>
                    <i className={`pi ${odrediste
                        ? 'pi-check-circle'
                        : (trazi ? 'pi-spin pi-spinner' : 'pi-search')}`} />
                    <input
                        id="plan-cilj"
                        type="text"
                        value={upit}
                        placeholder={t('gps.planOdredistePlaceholder')}
                        onChange={(e) => { razreseno.current = null; setUpit(e.target.value); setOdrediste(null); }}
                        autoComplete="off"
                    />
                    {!!odrediste && (
                        <button type="button" className="gps-plan-brisi"
                                onClick={ocistiOdrediste}
                                title={t('gps.pretragaOcisti')}
                                aria-label={t('gps.pretragaOcisti')}>
                            <i className="pi pi-times" />
                        </button>
                    )}
                </div>

                {!!predlozi.length && (
                    <div className="gps-plan-predlozi" role="listbox">
                        {/* Razvrstano po policama, jer se odredište zadaje na tri
                            načina i dispečer zna koji koristi pre nego što počne da
                            kuca. Prazna polica se ne ispisuje — naslov bez stavki
                            samo troši visinu spiska. */}
                        {POLICE.map(g => {
                            const stavke = predlozi.filter(x => x.polica === g.kljuc);
                            if (!stavke.length) return null;
                            return (
                                <div key={g.kljuc} className="gps-plan-polica">
                                    <div className="gps-plan-polica-naslov">{t(g.naslov)}</div>
                                    {stavke.map((p, i) => (
                                        <button key={`${p.lat}-${p.lng}-${i}`} type="button" role="option"
                                                aria-selected="false"
                                                className="gps-plan-predlog" onClick={() => izaberiOdrediste(p)}>
                                            <i className={IKONA_POLICE[g.kljuc]} />
                                            <span className="gps-plan-predlog-tekst">
                                                <span className="gps-plan-predlog-naziv">{p.naziv}</span>
                                                {!!p.opis && <span className="gps-plan-predlog-opis">{p.opis}</span>}
                                            </span>
                                            {/* Zemlja na kraju reda — po njoj se rezultat
                                                prepoznaje pre čitanja cele adrese. */}
                                            {!!p.zemlja && <span className="gps-plan-zemlja">{p.zemlja}</span>}
                                            {p.svoje && <span className="gps-plan-svoje">{p.znacka}</span>}
                                        </button>
                                    ))}
                                </div>
                            );
                        })}
                    </div>
                )}
            </div>
            </div>

            {/* Prekidač i legenda dele jedan red: legenda objašnjava oznake
                koje stoje odmah ISPOD nje, na karticama trasa, pa mora da se
                pročita pre njih a da ih pritom ne odgurne niže. */}
            <div className="gps-plan-alatke">
                <label className="gps-plan-prekidac" htmlFor="plan-putarine">
                    <InputSwitch inputId="plan-putarine" className="gps-prekidac"
                                 checked={putarine}
                                 onChange={(e) => promeniPutarine(e.value)} />
                    <span>{t('gps.planBezPutarina')}</span>
                </label>

                {/* Boje i ikone se ČITAJU iz istog izvora iz kog ih uzimaju i
                    kartice (`VRSTE`) — legenda koja se prepisuje ručno prestane
                    da važi prvi put kad se neka boja promeni. */}
                <div className="gps-plan-legenda">
                    <span className="gps-plan-legenda-naslov">{t('gps.planLegenda')}</span>

                    {['ZATVOREN', 'RADOVI'].map(v => (
                        <span key={v} className="gps-plan-legenda-stavka">
                            <i className={VRSTE[v].ikona} style={{ color: VRSTE[v].boja }} />
                            {t(VRSTE[v].naziv)}
                        </span>
                    ))}

                    {/* Kašnjenje nije vrsta događaja nego posledica — na kartici
                        stoji kao sat, pa i ovde. */}
                    <span className="gps-plan-legenda-stavka">
                        <i className="pi pi-clock gps-plan-legenda-sat" />
                        {t('gps.planLegendaKasni')}
                    </span>
                </div>
            </div>

            {racuna && (
                <div className="gps-plan-ceka">
                    <i className="pi pi-spin pi-spinner" /> {t('gps.planRacuna')}
                </div>
            )}

            {!!poruka && !racuna && <div className="gps-plan-greska">{poruka}</div>}

            {!racuna && !!rute.length && (
                /* U RED, ne jedan ispod drugog: tri trase se biraju poredjenjem,
                    a poredi se samo ono sto stoji jedno pored drugog. Uspravan
                    spisak trazi skrolovanje i pamcenje prve dok se cita treca. */
                <div className="gps-plan-rute">
                    {rute.map((r, i) => {
                        const s = sazetak(r.incidenti);
                        return (
                            <button
                                key={r.id}
                                type="button"
                                className={`gps-plan-ruta${i === izabrana ? ' gps-plan-ruta-izabrana' : ''}`}
                                onClick={() => izaberiRutu(i)}
                            >
                                <span className="gps-plan-ruta-vrh">
                                    {/* Isti broj kao na liniji na mapi — bez njega se
                                        kartica i trasa ne mogu spojiti. */}
                                    <span className="gps-plan-broj">{i + 1}</span>
                                    <span className="gps-plan-vreme">{sat(r.minuta)}</span>
                                    <span className="gps-plan-km">{r.km.toLocaleString('sr-RS', { maximumFractionDigits: 1 })} km</span>
                                    {/* Oznaka „najbrža" stoji samo na prvoj, i samo kad ih ima
                                        više — na jednoj ruti ne znači ništa. */}
                                    {r.najbolja && rute.length > 1 && (
                                        <span className="gps-plan-oznaka">{t('gps.planNajbolja')}</span>
                                    )}
                                </span>

                                {r.kasnjenjeMin > 0 && (
                                    <span className="gps-plan-kasni">
                                        <i className="pi pi-clock" />
                                        {t('gps.planKasni', { vreme: sat(r.kasnjenjeMin) })}
                                    </span>
                                )}

                                {/* Zatvoren put se javlja PRE broja radova: to je jedina
                                    stavka posle koje trasa možda uopšte ne važi. */}
                                {!!s.ukupno && (
                                    <span className="gps-plan-upozorenja">
                                        {!!s.zatvorenih && (
                                            <span className="gps-plan-znak gps-plan-znak-crveno">
                                                <i className="pi pi-ban" /> {s.zatvorenih}
                                            </span>
                                        )}
                                        {!!s.radova && (
                                            <span className="gps-plan-znak gps-plan-znak-narandzasto">
                                                <i className="pi pi-wrench" /> {s.radova}
                                            </span>
                                        )}
                                        <span className="gps-plan-znak">
                                            {t('gps.planUkupnoUpozorenja', { broj: s.ukupno })}
                                        </span>
                                    </span>
                                )}
                            </button>
                        );
                    })}
                </div>
            )}

            {/* Spisak onoga što čeka na IZABRANOJ trasi — poređan po tome koliko je
                daleko duž nje, jer dispečera zanima šta dolazi prvo. */}
            {!racuna && izabrana != null && !!(rute[izabrana]?.incidenti || []).length && (
                <div className="gps-plan-spisak">
                    <div className="gps-plan-spisak-naslov">{t('gps.planNaTrasi')}</div>
                    {rute[izabrana].incidenti.map(inc => {
                        const o = vrstaOpis(inc.vrsta);
                        const kasni = kasnjenjeTeksta(inc.kasnjenje);
                        return (
                            <div key={inc.id} className="gps-plan-inc">
                                <span className="gps-plan-inc-km">
                                    {inc.kmOdPocetka != null ? `${inc.kmOdPocetka.toLocaleString('sr-RS', { maximumFractionDigits: 0 })} km` : ''}
                                </span>
                                <i className={o.ikona} style={{ color: o.boja }} />
                                <span className="gps-plan-inc-tekst">
                                    <span className="gps-plan-inc-vrsta" style={{ color: o.boja }}>{t(o.naziv)}</span>
                                    {!!inc.naslov && <span className="gps-plan-inc-gde">{inc.naslov}</span>}
                                </span>
                                {!!kasni && <span className="gps-plan-inc-kasni">+{kasni}</span>}
                            </div>
                        );
                    })}
                </div>
            )}

            <div className="gps-plan-podnozje">
                <Button type="button" icon="pi pi-external-link" label={t('gps.googleOtvori')}
                        className="p-button-text p-button-sm"
                        disabled={!odrediste} onClick={naGoogle} />
                {/* Umesto „Zatvori": prozor se zatvara sa „×" u zaglavlju i
                    sklanja dugmetom pored njega, pa je treći izlaz na istom mestu
                    bio suvišan. Kopiranje linka je ono što ovde stvarno treba —
                    ruta se najčešće ne otvara nego ŠALJE vozaču. */}
                <Button type="button"
                        icon={kopirano ? 'pi pi-check' : 'pi pi-copy'}
                        label={t(kopirano ? 'gps.googleKopirano' : 'gps.googleKopiraj')}
                        className={`p-button-text p-button-sm${kopirano ? ' p-button-success' : ''}`}
                        disabled={!odrediste} onClick={naKopiraj} />
            </div>
        </Dialog>
    );
};

export default DialogPlanRute;
